module.exports = __webpack_public_path__ + "static/media/collapse-default.148fbfe6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/collapse-default.svg
// module id = 257
// module chunks = 0